<div class="bg-image">
    <div class="container section-wrap">
        <div class="verifyEmail" *ngIf="isVerified">
            <ng-container *ngIf="isEmailAlreadyVerified">
                <p>Your email has already been verified. No further action is needed.</p><br>
                <p>You'll be redirected to the login page in</p><br>
                <div class="d-flex justify-content-between align-items-center">
                <label><span>{{transform(counter)}}</span></label>
                </div>
                <p style="font-size: 24px;">If this doesn’t happen, <span><a href="/login" style="color: rgb(4 61 145);">[Click here to log in]</a></span> </p>
            </ng-container>
            <ng-container *ngIf="isLinkExpired"><p style="width: 57%;">Your verification link has expired. We’ve sent a new link to your registered email.</p><br>
                <p style="width: 57%;">Please check your inbox (and spam/junk folder) and use the new link to verify your account.</p>
            </ng-container>
            <ng-container *ngIf="isUserDeleted">
                <p>Your account is no longer active. Please contact Catholic Legacy for any support.
                    Redirecting to the login page...</p><br>
                <div class="d-flex justify-content-between align-items-center">
                    <label><span>{{transform(counter)}}</span></label>
                </div>
            </ng-container>
            <ng-container *ngIf="!isEmailAlreadyVerified && !isLinkExpired && !isUserDeleted"><p>Email is verified successfully</p>
                <div class="d-flex justify-content-between align-items-center">
                    <label><span>{{transform(counter)}}</span></label>
                </div>
            </ng-container>
        </div>
    </div>
</div>
        